import { AddGiftCardErrorCodeV1, AddGiftCardErrorV1 } from '@vista-digital/ocapi-client';
import { runInAction } from 'mobx';
import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { CommonErrorCodes } from '../../../../types/errors/common-error-codes';
import { logger } from '../../../../utils/logger';
import { giftCardPaymentCreateValidator } from '../../../../utils/validators/gift-card-payment-create';
import { OrderDomainError, OrderDomainSpecificErrorCode } from '../../errors/order-domain-error';
import { getOrder } from '../../selectors/order/get-order';
import { assertIsOrderCreated } from '../../utils/order-type-utils';
import { registerOrderAction } from '../utils/register-order-action';
export const addOrderGiftCardPayment = async (request) => {
    const order = getOrder();
    assertIsOrderCreated(order, 'Cannot add gift card payment');
    if (!giftCardPaymentCreateValidator(request, logger.info, 'OrderGiftCardPaymentCreate')) {
        throw new Error('Cannot add gift card payment. Details provided are invalid.');
    }
    let response;
    const deregisterAction = registerOrderAction('add-order-gift-card-payment');
    try {
        response = await ocapiClient.instance.v1.orders.payments.giftCard.add(order.id, request);
    }
    catch (error) {
        if (error instanceof AddGiftCardErrorV1) {
            const errorCode = convertApiToDomainErrorCode(error.errorCode);
            throw new OrderDomainError(errorCode, error.message);
        }
        throw error;
    }
    finally {
        deregisterAction();
    }
    runInAction(() => {
        order.payments.push(response);
    });
    return response;
};
function convertApiToDomainErrorCode(errorCode) {
    switch (errorCode) {
        case AddGiftCardErrorCodeV1.InvalidCardNumberOrPin:
            return OrderDomainSpecificErrorCode.GiftCardCredentialsInvalid;
        case AddGiftCardErrorCodeV1.Expired:
            return OrderDomainSpecificErrorCode.GiftCardExpired;
        case AddGiftCardErrorCodeV1.InsufficientBalance:
            return OrderDomainSpecificErrorCode.InsufficientGiftCardBalance;
        case AddGiftCardErrorCodeV1.AlreadyAdded:
            return OrderDomainSpecificErrorCode.GiftCardAlreadyAdded;
        default:
            return CommonErrorCodes.UnknownError;
    }
}
